import { ClusterComputed, useCurCluster, useCurOrg } from '~/hooks/state'

// ClusterInfo type
export type ClusterInfo = {
  orgId: string
  orgExternalId: string
  projectId: string
  clusterId: string
  clusterProvider: string
  clusterRegion: string
  deployType: string
  computed: ClusterComputed
}

// Statement API types
export interface ApiModel {
  digest?: string
  digest_text?: string
  schema_name?: string
  sum_latency?: number
  avg_latency?: number
  max_latency?: number
  min_latency?: number
  exec_count?: number
  plan_count?: number
  sum_ru?: number
  avg_ru?: number
  summary_begin_time?: number
  summary_end_time?: number
  plan_digest?: string
  avg_total_keys?: number
  avg_processed_keys?: number
  [key: string]: any
}

export interface SlowquerySlowLogRespItem {
  query?: string
  timestamp?: number
  query_time?: number
  memory_max?: number
  connection_id?: string
  [key: string]: any
}

// Helper to convert ClusterCluster to ClusterInfo
export function useClusterToClusterInfo(): ClusterInfo {
  const { curOrg } = useCurOrg()
  const { curCluster } = useCurCluster()
  const orgId = curOrg?.id ?? ''
  const projectId = curCluster?.projectID ?? ''

  return {
    orgId,
    orgExternalId: curOrg?.externalID ?? '',
    projectId,
    clusterId: curCluster?.id ?? '',
    clusterProvider: curCluster?.provider ?? '',
    clusterRegion: curCluster?.region ?? '',
    deployType: curCluster?.deployType ?? '',
    computed: curCluster?.computed ?? ({} as ClusterComputed)
  }
}
